import { Link } from "react-router-dom";
import { Scissors, Instagram, Youtube, Mail } from "lucide-react";
import { usePublicSettings } from "@/lib/usePublicSettings";
import { gaEvent } from "@/lib/analytics";

export function Footer() {
  const { contact_email, instagram_url, youtube_url, footer_description, copyright_text } = usePublicSettings();
  return (
    <footer className="border-t border-white/10 bg-black mt-24">
      <div className="mx-auto max-w-7xl px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <Scissors className="h-6 w-6 text-[#DCA846]" />
            <span className="font-display text-xl font-bold uppercase tracking-wider">Epic Fade Academy</span>
          </div>
          <p className="mt-4 max-w-sm text-sm text-zinc-400 leading-relaxed">
            {footer_description || "Premium, cinematic barber education. Master fades, tapers, beard work and the business of barbering from industry masters."}
          </p>
          <div className="mt-6 flex gap-4 text-zinc-400">
            {instagram_url && (
              <a href={instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" onClick={() => gaEvent("instagram_click", { link_url: instagram_url, source: "footer" })} className="hover:text-[#DCA846]"><Instagram className="h-5 w-5" /></a>
            )}
            {youtube_url && (
              <a href={youtube_url} target="_blank" rel="noreferrer" data-testid="footer-youtube" aria-label="YouTube" className="hover:text-[#DCA846]"><Youtube className="h-5 w-5" /></a>
            )}
            {contact_email && (
              <a href={`mailto:${contact_email}`} data-testid="footer-email" aria-label="Email" className="hover:text-[#DCA846]"><Mail className="h-5 w-5" /></a>
            )}
          </div>
        </div>
        <div>
          <h4 className="font-display uppercase tracking-wider text-sm text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/store" className="hover:text-[#DCA846]">All Courses</Link></li>
            <li><Link to="/store?free=true" className="hover:text-[#DCA846]">Free Lessons</Link></li>
            <li><Link to="/portfolio" className="hover:text-[#DCA846]">My Work</Link></li>
            <li><Link to="/my-learning" className="hover:text-[#DCA846]">My Learning</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display uppercase tracking-wider text-sm text-white mb-4">Legal</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/legal/privacy" className="hover:text-[#DCA846]">Privacy Policy</Link></li>
            <li><Link to="/legal/terms" className="hover:text-[#DCA846]">Terms & Conditions</Link></li>
            <li><Link to="/legal/refund" className="hover:text-[#DCA846]">Refund Policy</Link></li>
            <li><Link to="/legal/faq" className="hover:text-[#DCA846]">FAQ</Link></li>
            <li><Link to="/legal/contact" className="hover:text-[#DCA846]">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-zinc-600">
        {copyright_text || `\u00A9 ${new Date().getFullYear()} Epic Fade Academy. All rights reserved.`}
      </div>
    </footer>
  );
}
